import { Tooltip } from 'primereact/tooltip';

export const InfoIcon = ({...buttonProps}) => (
  <svg {...buttonProps}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    />
  </svg>
)

export const ErrorInfoIcon = ({...buttonProps}) => (
  <svg {...buttonProps}
    className="w-4 h-4 cursor-pointer"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="#dc2626"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    />
  </svg>
)

export const HamburgerIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="w-5 h-5"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 17 14"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M1 1h15M1 7h15M1 13h15"
    />
  </svg>
)

export const LogoutIcon = ({...buttonProps}) => (
  <svg {...buttonProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" className="fill-current h-4 w-4"
    fill="currentColor">
    <g fill="currentColor" transform="scale(0.01953125 0.01953125)">
      <path
        d="M972.8 512l-307.2-256v153.6h-358.4v204.8h358.4v153.6l307.2-256zM153.6 153.6h409.6v-102.4h-409.6c-56.32 0-102.4 46.080-102.4 102.4v716.8c0 56.32 46.080 102.4 102.4 102.4h409.6v-102.4h-409.6v-716.8z" />
    </g>
  </svg>
)

export const SearchIcon = ({...buttonProps}) => (
  <svg {...buttonProps} xmlns="http://www.w3.org/2000/svg" width="16" height="16" className="DocSearch-Search-Icon" viewBox="0 0 20 20">
    <path
      d="M14.386 14.386l4.0877 4.0877-4.0877-4.0877c-2.9418 2.9419-7.7115 2.9419-10.6533 0-2.9419-2.9418-2.9419-7.7115 0-10.6533 2.9418-2.9419 7.7115-2.9419 10.6533 0 2.9419 2.9418 2.9419 7.7115 0 10.6533z"
      stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
    </path>
  </svg>
)

export const ClearSearchIcon = ({...buttonProps}) => (
  <svg {...buttonProps}
    className="w-3 h-3"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
      />
  </svg>
)

export const FilterIcon = ({...buttonProps}) => (
  <svg {...buttonProps}
    className="ml-2 w-[1.3rem] h-[1.3rem]"
    fill="currentColor"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M640 288a64 64 0 1 1 0.032-128.032A64 64 0 0 1 640 288z m123.456-96c-14.304-55.04-64-96-123.456-96s-109.152 40.96-123.456 96H128v64h388.544c14.304 55.04 64 96 123.456 96s109.152-40.96 123.456-96H896V192h-132.544zM640 864a64 64 0 1 1 0.032-128.032A64 64 0 0 1 640 864m0-192c-59.456 0-109.152 40.96-123.456 96H128v64h388.544c14.304 55.04 64 96 123.456 96s109.152-40.96 123.456-96H896v-64h-132.544c-14.304-55.04-64-96-123.456-96M384 576a64 64 0 1 1 0.032-128.032A64 64 0 0 1 384 576m0-192c-59.456 0-109.152 40.96-123.456 96H128v64h132.544c14.304 55.04 64 96 123.456 96s109.152-40.96 123.456-96H896v-64H507.456c-14.304-55.04-64-96-123.456-96" />
  </svg>
)

export const ClearFilterIcon = ({...buttonProps}) => (
  <svg {...buttonProps}
    className="shrink-0 size-3.5"
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round">
    <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
    <path d="M3 3v5h5"></path>
    <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"></path>
    <path d="M16 16h5v5"></path>
  </svg>
)

export const CollapseFilterIcon = ({...buttonProps}) => (
  <svg
    className="w-4 h-4"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 19L11.2929 12.7071C11.6834 12.3166 12.3166 12.3166 12.7071 12.7071L19 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
    <path d="M5 11L11.2929 4.70711C11.6834 4.31658 12.3166 4.31658 12.7071 4.70711L19 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
  </svg>
)

export const SortAscIcon = ({...buttonProps}) => (
  <svg {...buttonProps}
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 320 512"
  fill="currentColor"
  className="w-4 h-4 size-6 cursor-pointer text-white"
  >
    <path
      d="M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z" />
</svg>
)

export const SortDescIcon = ({...buttonProps}) => (
  <svg {...buttonProps}
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 320 512"
  fill="currentColor"
  className="w-4 h-4 size-6 cursor-pointer text-white rotate-180"
  >
    <path
      d="M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z" />
</svg>
)

export const NoSortIcon = ({...buttonProps}) => (
  <svg {...buttonProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor"
    className="w-4 h-4 size-6 cursor-pointer text-white rotate-180">
    <path
      d="M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8L32 224c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z" />
  </svg>
)

export const WarningIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
  </svg>
)

export const CheckCircleIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="h-6 w-6 text-green-600" fill="currentColor" viewBox="0 0 24 24">
    <path fillRule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l4-4Z" clipRule="evenodd"/>
  </svg>
)

export const CloseModalIcon = ({...buttonProps}) => (
  <svg {...buttonProps}
    className="w-3 h-3"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
      />
  </svg>
)

export const SiteNotiIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="text-yellow-400 w-9 h-9" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
    viewBox="0 0 24 24">
    <path fillRule="evenodd"
      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0V8Zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z"
      clipRule="evenodd"></path>
  </svg>
)

export const BlankPhotoIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="w-10 h-10 text-gray-200" aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
    <path
      d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
  </svg>
)

export const SelectFileIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="w-8 h-8 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
    fill="none" viewBox="0 0 20 16">
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2">
    </path>
  </svg>
)

export const NGFileExpIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="w-6 h-6 text-red-600 mr-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
    height="24" fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
      d="m15 9-6 6m0-6 6 6m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"></path>
  </svg>
)

export const GenerateAfterPhotoIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
    fill="currentColor" viewBox="0 0 24 24">
    <path fillRule="evenodd"
      d="M17.44 3a1 1 0 0 1 .707.293l2.56 2.56a1 1 0 0 1 0 1.414L18.194 9.78 14.22 5.806l2.513-2.513A1 1 0 0 1 17.44 3Zm-4.634 4.22-9.513 9.513a1 1 0 0 0 0 1.414l2.56 2.56a1 1 0 0 0 1.414 0l9.513-9.513-3.974-3.974ZM6 6a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2H7v1a1 1 0 1 1-2 0v-1H4a1 1 0 0 1 0-2h1V7a1 1 0 0 1 1-1Zm9 9a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z"
      clipRule="evenodd"></path>
    <path d="M19 13h-2v2h2v-2ZM13 3h-2v2h2V3Zm-2 2H9v2h2V5ZM9 3H7v2h2V3Zm12 8h-2v2h2v-2Zm0 4h-2v2h2v-2Z"></path>
  </svg>
)

export const ReloadRoomDesignIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="w-5 h-5 mr-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
    fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
      d="M17.651 7.65a7.131 7.131 0 0 0-12.68 3.15M18.001 4v4h-4m-7.652 8.35a7.13 7.13 0 0 0 12.68-3.15M6 20v-4h4" />
  </svg>
)

export const DelPhotoIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="w-5 h-5 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
    width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
    <path fillRule="evenodd"
      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm7.707-3.707a1 1 0 0 0-1.414 1.414L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L13.414 12l2.293-2.293a1 1 0 0 0-1.414-1.414L12 10.586 9.707 8.293Z"
      clipRule="evenodd" />
  </svg>
)

export const AddMorePhotoIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
    fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
      d="M5 12h14m-7 7V5" />
  </svg>
)

export const PhotoOptionRequireIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="text-yellow-400 w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
    fill="currentColor" viewBox="0 0 24 24">
    <path fillRule="evenodd"
      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0V8Zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z"
      clipRule="evenodd"></path>
  </svg>
)

export const ConfirmGenerateAfterPhotoIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="w-8 h-8 text-blue-700" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
    height="24" fill="currentColor" viewBox="0 0 24 24">
    <path fillRule="evenodd"
      d="M17.44 3a1 1 0 0 1 .707.293l2.56 2.56a1 1 0 0 1 0 1.414L18.194 9.78 14.22 5.806l2.513-2.513A1 1 0 0 1 17.44 3Zm-4.634 4.22-9.513 9.513a1 1 0 0 0 0 1.414l2.56 2.56a1 1 0 0 0 1.414 0l9.513-9.513-3.974-3.974ZM6 6a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2H7v1a1 1 0 1 1-2 0v-1H4a1 1 0 0 1 0-2h1V7a1 1 0 0 1 1-1Zm9 9a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z"
      clipRule="evenodd"></path>
    <path d="M19 13h-2v2h2v-2ZM13 3h-2v2h2V3Zm-2 2H9v2h2V5ZM9 3H7v2h2V3Zm12 8h-2v2h2v-2Zm0 4h-2v2h2v-2Z"></path>
  </svg>
)

export const AfterImageDownloadIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="w-[35px] h-[35px] text-gray-700 dark:text-gray-200"
    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
    <path fillRule="evenodd"
      d="M13 11.15V4a1 1 0 1 0-2 0v7.15L8.78 8.374a1 1 0 1 0-1.56 1.25l4 5a1 1 0 0 0 1.56 0l4-5a1 1 0 1 0-1.56-1.25L13 11.15Z"
      clipRule="evenodd" />
    <path fillRule="evenodd"
      d="M9.657 15.874 7.358 13H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2.358l-2.3 2.874a3 3 0 0 1-4.685 0ZM17 16a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H17Z"
      clipRule="evenodd" />
  </svg>
)

export const AfterImageBackwardIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="w-4 h-4 text-gray-400 dark:text-gray-200 rtl:rotate-180" aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
      d="M5 1 1 5l4 4" />
  </svg>
)

export const AfterImageForwardIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="w-4 h-4 text-gray-400 dark:text-gray-200 rtl:rotate-180" aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
      d="m1 9 4-4-4-4" />
  </svg>
)

export const DropdownIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="pointer-events-none z-10 right-1 relative col-start-1 row-start-1 h-4 w-4 self-center justify-self-end forced-colors:hidden dark:text-white" viewBox="0 0 16 16" fill="currentColor">
    <path fillRule="evenodd" d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z" clipRule="evenodd"></path>
  </svg>
)

export const ShowPassword = ({...buttonProps}) => (
  <svg {...buttonProps} className="w-6 h-6 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" strokeWidth="2" d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z"/>
    <path stroke="currentColor" strokeWidth="2" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
  </svg>
)

export const HidePassword = ({...buttonProps}) => (
  <svg {...buttonProps} className="w-6 h-6 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.933 13.909A4.357 4.357 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.068 5.068 0 0 1 21 12c0 1-3 6-9 6-.314 0-.62-.014-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
  </svg>
)

export const EditPassword = ({...buttonProps}) => (
  <svg {...buttonProps} className="svg-icon w-5 h-5" fill="currentColor" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path d="M288 416v-96a128 128 0 0 1 256 0v96h64v-96c0-106-86-192-192-192s-192 86-192 192v96zM512 704h-64v-64l384-384 64 64-384 384z" stroke="currentColor"></path>
    <path d="M544 736H416V608l160-160H192a64.19 64.19 0 0 0-64 64v320a64.19 64.19 0 0 0 64 64h448a64.19 64.19 0 0 0 64-64V576z"></path>
  </svg>
)

export const LoadingIcon = ({...buttonProps}) => (
  <svg {...buttonProps} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"><animateTransform attributeName="transform" dur="0.75s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12"/></path></svg>
)

export const LeadPencilIcon = ({...buttonProps}) => (
  <svg {...buttonProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M16.84,2.73C16.45,2.73 16.07,2.88 15.77,3.17L13.65,5.29L18.95,10.6L21.07,8.5C21.67,7.89 21.67,6.94 21.07,6.36L17.9,3.17C17.6,2.88 17.22,2.73 16.84,2.73M12.94,6L4.84,14.11L7.4,14.39L7.58,16.68L9.86,16.85L10.15,19.41L18.25,11.3M4.25,15.04L2.5,21.73L9.2,19.94L8.96,17.78L6.65,17.61L6.47,15.29" /></svg>
)

export const TriangleOutlineIcon = ({ ...buttonProps }) => (
  <svg
    {...buttonProps}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 2L2 21H22L12 2Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export const CircleOutlineIcon = ({ ...buttonProps }) => (
  <svg
    {...buttonProps}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);


export const SquareOutlineIcon = ({ ...buttonProps }) => (
  <svg
    {...buttonProps}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="4"
      y="4"
      width="16"
      height="16"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);


export const UndoIcon = ({ ...buttonProps }) => (
  <svg { ...buttonProps } xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20 13.5C20 17.09 17.09 20 13.5 20H6V18H13.5C16 18 18 16 18 13.5S16 9 13.5 9H7.83L10.91 12.09L9.5 13.5L4 8L9.5 2.5L10.92 3.91L7.83 7H13.5C17.09 7 20 9.91 20 13.5Z" /></svg>
)

export const RedoIcon = ({ ...buttonProps }) => (
  <svg { ...buttonProps } xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10.5 18H18V20H10.5C6.91 20 4 17.09 4 13.5S6.91 7 10.5 7H16.17L13.08 3.91L14.5 2.5L20 8L14.5 13.5L13.09 12.09L16.17 9H10.5C8 9 6 11 6 13.5S8 18 10.5 18Z" /></svg>
)

export const NoticeIcon = ({ ...buttonProps }) => (
  <>
    <Tooltip target=".notice-icon"
      className='tooltip'
    />
    <svg { ...buttonProps } className="notice-icon w-5 h-5 cursor-pointer" aria-hidden="true"
      data-pr-tooltip="【あり】を選択した場合、畳の上に家具を配置しない処理を行います。"
      data-pr-position="right"
      data-pr-at="right+5 top-15"
      data-pr-my="left center-2"
      xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
        d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
    </svg>
  </>
)

export const NoticeRoleIcon = ({ ...buttonProps }) => (
  <>
    <Tooltip target=".role-info-icon"
      className='orange-tooltip'
    />
    <svg { ...buttonProps } className="role-info-icon w-5 h-5 cursor-pointer" aria-hidden="true"
      data-pr-tooltip={"\
        ・一般ユーザー（らくデコ機能のみ利用可能）\n \
        ・閲覧ユーザー（管理者画面のみ閲覧可能）\n \
        ・管理者ユーザー（らくデコ機能・管理者画面を利用可能）\n"
      }
      data-pr-position="right"
      data-pr-at="right+5 top"
      data-pr-my="left center-2"
      xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
        d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
    </svg>
  </>
)

// 一括ユーザー登録用のバリデーションルール説明アイコン（共通部分）
interface NoticeBulkIconProps {
  targetClass: string;
  tooltip: string;
}

const NoticeBulkIconBase = ({ targetClass, tooltip }: NoticeBulkIconProps) => (
  <>
    <Tooltip target={`.${targetClass}`} className="orange-tooltip" />
    <svg
      className={`${targetClass} w-4 h-4 cursor-pointer`}
      aria-hidden="true"
      data-pr-tooltip={tooltip}
      data-pr-position="bottom"
      data-pr-at="center bottom+5"
      data-pr-my="center top"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
      />
    </svg>
  </>
);

export const NoticeBulkLoginIdAndPasswordIcon = () => (
  <NoticeBulkIconBase
    targetClass="bulk-login-id-password-info-icon"
    tooltip={`・半角英数字、ドット（.）、アンダースコア（_）、ハイフン（-）、アットマーク（@）のみ使用可能\n・4〜64文字\n・重複不可`}
  />
);

export const NoticeBulkUserNameIcon = () => (
  <NoticeBulkIconBase
    targetClass="bulk-user-name-info-icon"
    tooltip="1〜255文字"
  />
);

export const NoticeBulkEmailIcon = () => (
  <NoticeBulkIconBase
    targetClass="bulk-email-info-icon"
    tooltip={`有効なメールアドレス形式\n例）taro.yamaga@example.com`}
  />
);

export const NoticeBulkRoleIcon = () => (
  <NoticeBulkIconBase
    targetClass="bulk-role-info-icon"
    tooltip={`以下のいずれかを設定\n・一般ユーザー（らくデコ機能のみ利用可能）\n・閲覧ユーザー（管理者画面のみ閲覧可能）\n・管理者ユーザー（らくデコ機能・管理者画面を利用可能）\n※ 未指定の場合は一般ユーザー`}
  />
);

export const NoticeBulkCreditLimitIcon = () => (
  <NoticeBulkIconBase
    targetClass="bulk-credit-limit-info-icon"
    tooltip={`0以上の整数を設定\n※ 空の場合は「上限なし」`}
  />
);

export const VideoCameraIcon = ({ ...buttonProps }) => (
  <svg {...buttonProps} className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
    <path fill-rule="evenodd" d="M14 7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7Zm2 9.387 4.684 1.562A1 1 0 0 0 22 17V7a1 1 0 0 0-1.316-.949L16 7.613v8.774Z" clip-rule="evenodd"/>
  </svg>
)

export const LockIcon = ({ ...buttonProps }) => (
  <svg {...buttonProps} className="w-6 h-6 text-yellow-400 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
    <path fill-rule="evenodd" d="M8 10V7a4 4 0 1 1 8 0v3h1a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h1Zm2-3a2 2 0 1 1 4 0v3h-4V7Zm2 6a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z" clip-rule="evenodd"/>
  </svg>
)

export const DotsVerticalIcon = ({ ...buttonProps }) => (
  <svg {...buttonProps} className="w-6 h-6 text-white dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" strokeLinecap="round" strokeWidth="2" d="M6 6h.01M6 12h.01M6 18h.01"/>
    <path stroke="currentColor" strokeLinecap="round" strokeWidth="2" d="M12 6h.01M12 12h.01M12 18h.01"/>
  </svg>
)

export const TrashIcon = ({ ...buttonProps }) => (
  <svg {...buttonProps} className="w-6 h-6 text-white dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"/>
  </svg>
)
export const LinkIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="w-4 h-4 inline-block" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/>
  </svg>
)

export const LinkOffIcon = ({...buttonProps}) => (
  <svg {...buttonProps} className="w-4 h-4 inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M13.181 8.68a4.503 4.503 0 0 1 1.903 6.405m-9.768-2.782L3.56 14.06a4.5 4.5 0 0 0 6.364 6.365l3.129-3.129m5.614-5.615 1.757-1.757a4.5 4.5 0 0 0-6.364-6.365l-4.5 4.5c-.258.26-.479.541-.661.84m1.903 6.405a4.495 4.495 0 0 1-1.242-.88 4.483 4.483 0 0 1-1.062-1.683m6.587 2.345 5.907 5.907m-5.907-5.907L8.898 8.898M2.991 2.99 8.898 8.9" />
  </svg>
)

export const UserCircleIcon = ({ ...buttonProps }) => (
  <svg {...buttonProps}  className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0 0a8.949 8.949 0 0 0 4.951-1.488A3.987 3.987 0 0 0 13 16h-2a3.987 3.987 0 0 0-3.951 3.512A8.948 8.948 0 0 0 12 21Zm3-11a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
  </svg>
)

export const UserSettingsIcon = ({ ...buttonProps }) => (
  <svg {...buttonProps} className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" strokeLinecap="square" strokeLinejoin="round" strokeWidth="2" d="M10 19H5a1 1 0 0 1-1-1v-1a3 3 0 0 1 3-3h2m10 1a3 3 0 0 1-3 3m3-3a3 3 0 0 0-3-3m3 3h1m-4 3a3 3 0 0 1-3-3m3 3v1m-3-4a3 3 0 0 1 3-3m-3 3h-1m4-3v-1m-2.121 1.879-.707-.707m5.656 5.656-.707-.707m-4.242 0-.707.707m5.656-5.656-.707.707M12 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
  </svg>
)

export const PlusIcon = ({ ...buttonProps }) => (
  <svg {...buttonProps} className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5v14m-7-7h14"/>
  </svg>
)

export const FileImportIcon = ({ ...buttonProps }) => (
  <svg {...buttonProps} className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
    <path fillRule="evenodd" d="M9 7V2.221a2 2 0 0 0-.5.365L4.586 6.5a2 2 0 0 0-.365.5H9Zm2 0V2h7a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-5h7.586l-.293.293a1 1 0 0 0 1.414 1.414l2-2a1 1 0 0 0 0-1.414l-2-2a1 1 0 0 0-1.414 1.414l.293.293H4V9h5a2 2 0 0 0 2-2Z" clipRule="evenodd"/>
  </svg>
)

export const ImageAddIcon = ({...buttonProps}) => (
  <svg {...buttonProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor">
    <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm40-80h480L570-480 450-320l-90-120-120 160Zm-40 80v-560 560Z"/>
  </svg>
)

export const CursorIcon = ({ ...buttonProps }) => (
  <svg {...buttonProps} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M7 2l10 8-4.5 1.2 2.8 5.6-2 1-2.8-5.6L7 15V2z"/>
  </svg>
)

export const EraserIcon = ({ ...buttonProps }) => (
  <svg {...buttonProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor">
    <path d="M690-240h190v80H610l80-80Zm-500 80-85-85q-23-23-23.5-57t22.5-58l440-456q23-24 56.5-24t56.5 23l199 199q23 23 23 57t-23 57L520-160H190Zm296-80 314-322-198-198-442 456 64 64h262Zm-6-240Z"/>
  </svg>
)

export const TextAlignLeftIcon = ({ ...buttonProps }) => (
  <svg {...buttonProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 4h18v2H3V4zm0 4h12v2H3V8zm0 4h18v2H3v-2zm0 4h12v2H3v-2zm0 4h18v2H3v-2z"/>
  </svg>
)

export const TextAlignCenterIcon = ({ ...buttonProps }) => (
  <svg {...buttonProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 4h18v2H3V4zm3 4h12v2H6V8zm-3 4h18v2H3v-2zm3 4h12v2H6v-2zm-3 4h18v2H3v-2z"/>
  </svg>
)

export const TextAlignRightIcon = ({ ...buttonProps }) => (
  <svg {...buttonProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 4h18v2H3V4zm6 4h12v2H9V8zm-6 4h18v2H3v-2zm6 4h12v2H9v-2zm-6 4h18v2H3v-2z"/>
  </svg>
)

export const TextAlignJustifyIcon = ({ ...buttonProps }) => (
  <svg {...buttonProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 4h18v2H3V4zm0 4h18v2H3V8zm0 4h18v2H3v-2zm0 4h18v2H3v-2zm0 4h18v2H3v-2z"/>
  </svg>
)

export const VerticalAlignTopIcon = ({ ...buttonProps }) => (
  <svg {...buttonProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    <path d="M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z"/>
  </svg>
)

export const VerticalAlignMiddleIcon = ({ ...buttonProps }) => (
  <svg {...buttonProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    <path d="M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z"/>
  </svg>
)

export const VerticalAlignBottomIcon = ({ ...buttonProps }) => (
  <svg {...buttonProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z"/>
  </svg>
)

export const TextColorIcon = ({ className, barColor = "currentColor", ...buttonProps }: { className?: string; barColor?: string; [key: string]: any }) => (
  <svg
    className={className}
    width="20"
    height="20"
    {...buttonProps}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
  >
    <path d="M80 0v-160h800V0H80Z" fill={barColor}/>
    <path d="M220-280 430-840h100l210 560h-96l-50-144H368l-52 144h-96Zm176-224h168l-82-232h-4l-82 232Z" fill="currentColor"/>
  </svg>
)

export const BackgroundColorIcon = ({ className, barColor = "currentColor", ...buttonProps }: { className?: string; barColor?: string; [key: string]: any }) => (
  <svg
    className={className}
    width="20"
    height="20"
    {...buttonProps}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
  >
    <path d="M80 0v-160h800V0H80Z" fill={barColor}/>
    <path d="m247-904 57-56 343 343q23 23 23 57t-23 57L457-313q-23 23-57 23t-57-23L153-503q-23-23-23-57t23-57l190-191-96-96Zm153 153L209-560h382L400-751Zm360 471q-33 0-56.5-23.5T680-360q0-21 12.5-45t27.5-45q9-12 19-25t21-25q11 12 21 25t19 25q15 21 27.5 45t12.5 45q0 33-23.5 56.5T760-280Z" fill="currentColor"/>
  </svg>
)

export const StrokeColorIcon = ({ className, ...buttonProps }: { className?: string; [key: string]: any }) => (
  <svg
    className={className}
    {...buttonProps}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M16.84,2.73C16.45,2.73 16.07,2.88 15.77,3.17L13.65,5.29L18.95,10.6L21.07,8.5C21.67,7.89 21.67,6.94 21.07,6.36L17.9,3.17C17.6,2.88 17.22,2.73 16.84,2.73M12.94,6L4.84,14.11L7.4,14.39L7.58,16.68L9.86,16.85L10.15,19.41L18.25,11.3M4.25,15.04L2.5,21.73L9.2,19.94L8.96,17.78L6.65,17.61L6.47,15.29"/>
  </svg>
)

export const StrokeWidthIcon = ({ className, ...buttonProps }: { className?: string; [key: string]: any }) => (
  <svg
    className={className}
    width="20"
    height="20"
    {...buttonProps}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
    <line x1="3" y1="12" x2="21" y2="12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
    <line x1="3" y1="18" x2="21" y2="18" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
  </svg>
)

export const PencilColorIcon = ({ className, barColor = "currentColor", ...buttonProps }: { className?: string; barColor?: string; [key: string]: any }) => (
  <svg
    className={className}
    {...buttonProps}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 28"
    fill="currentColor"
  >
    {/* 鉛筆アイコン */}
    <path d="M16.84,2.73C16.45,2.73 16.07,2.88 15.77,3.17L13.65,5.29L18.95,10.6L21.07,8.5C21.67,7.89 21.67,6.94 21.07,6.36L17.9,3.17C17.6,2.88 17.22,2.73 16.84,2.73M12.94,6L4.84,14.11L7.4,14.39L7.58,16.68L9.86,16.85L10.15,19.41L18.25,11.3M4.25,15.04L2.5,21.73L9.2,19.94L8.96,17.78L6.65,17.61L6.47,15.29" />
    {/* 下部のカラーバー */}
    <rect x="2" y="24" width="20" height="3" fill={barColor} />
  </svg>
)

export const BandIcon = ({ ...buttonProps }) => (
  <svg {...buttonProps} className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <rect x="3" y="8" width="18" height="8" rx="1" stroke="currentColor" strokeWidth="2" fill="none"/>
    <line x1="7" y1="8" x2="7" y2="16" stroke="currentColor" strokeWidth="1.5"/>
    <line x1="12" y1="8" x2="12" y2="16" stroke="currentColor" strokeWidth="1.5"/>
    <line x1="17" y1="8" x2="17" y2="16" stroke="currentColor" strokeWidth="1.5"/>
  </svg>
)
